import loadSubscribeToProduct from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/ProductSubscribe";
import loadUnsubscribeToProduct from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/ProductUnsubscribe";
import { getProductStatusMultiSelector } from "@aihCustomBlueprint/Store/Data/AihCustomProductSubscribe/ProductSubscriptionSelector";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    erpNumber: string;
    productSubscribed?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {
    loadUnsubscribeToProduct,
    loadSubscribeToProduct,
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ResolveThunks<typeof mapDispatchToProps>;

const subscribeStyles: InjectableCss = {
    css: css`
        background: #0072bc;
        border: 1px solid #0072bc;
        color: white;
        border-radius: 7px;
        font-size: 10px;
        padding: 0 15px;
        min-height: 30px;
    `,
};

const unsubscribeStyles: InjectableCss = {
    css: css`
        background: white;
        border: 1px solid #0072bc;
        color: #0072bc;
        border-radius: 7px;
        font-size: 10px;
        padding: 0 15px;
        min-height: 30px;
    `,
};
const ProductSubscriptionWidget: FC<Props> = ({
    erpNumber: productErpNumber,
    productSubscribed = false,
    loadUnsubscribeToProduct,
    loadSubscribeToProduct,
}) => {
    const [subscribed, setSubscribed] = useState(productSubscribed);

    const subscribedProducts = useSelector(getProductStatusMultiSelector);

    // Check if the current product is subscribed
    useEffect(() => {
        if (subscribedProducts && subscribedProducts.length > 0) {
            const isSubscribed = subscribedProducts.some(product => product.erpNumber === productErpNumber);
            setSubscribed(isSubscribed);
        }
    }, [subscribedProducts, productErpNumber]);

    // Handler to subscribe the product
    const handleSubscribe = () => {
        loadSubscribeToProduct({
            productErpNumber,
            onSuccess: result => {
                if (result?.Success) {
                    setSubscribed(true);
                }
            },
            onError: () => {},
        });
    };

    // Handler to unsubscribe the product
    const handleUnsubscribe = () => {
        loadUnsubscribeToProduct({
            productErpNumber,
            onSuccess: () => {
                setSubscribed(false);
            },
            onError: () => {},
        });
    };

    return (
        <div>
            {!subscribed ? (
                <Button data-test-selector="btnSubscribe" onClick={handleSubscribe} {...subscribeStyles}>
                    {translate("Subscribe")}
                </Button>
            ) : (
                <Button data-test-selector="btnSubscribe" onClick={handleUnsubscribe} {...unsubscribeStyles}>
                    {translate("Unsubscribe")}
                </Button>
            )}
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSubscriptionWidget);
